module.exports = __webpack_public_path__ + "img/Tropical-sunset.941fd796.png";